import cn from "app/util/classnames";
import { Fragment } from "react";

interface SegmentedProgressBarProps {
  className?: string;
  numSteps: number;
  // Zero-based index
  currentStep: number;
}

// A row of numbered nodes joined by horizontal connectors, filled in to
// communicate progress through a series of steps.
export default function SegmentedProgressBar({
  className = "",
  numSteps,
  currentStep,
}: SegmentedProgressBarProps) {
  return (
    <div className={cn("flex items-center w-full", className)}>
      {Array.from({ length: numSteps }, (_, i) => {
        const isCompleted = i < currentStep;
        const isCurrent = i === currentStep;
        const isFilled = i <= currentStep;
        return (
          <Fragment key={i}>
            {i > 0 && (
              <div
                className={cn(
                  "grow h-2",
                  isFilled ? "bg-black" : "bg-green-dark",
                )}
              />
            )}
            <div
              className={cn(
                "flex items-center justify-center shrink-0",
                "w-7 h-7 rounded-full",
                "text-sm font-semibold",
                isCompleted && "bg-black text-green-mid",
                isCurrent &&
                  "bg-black text-yellow ring-2 ring-yellow scale-110",
                !isFilled && "bg-green-dark text-black",
              )}
            >
              {i + 1}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
